import React from 'react';

import { PageHeader } from '../ui/PageHeader';
import { Card } from '../ui/Card';

const values = ['Integrity', 'Community empowerment', 'Sustainability', 'Transparency', 'Fair collaboration'];

export default function AboutPage() {
  return (
    <div className="page heroPage">
      <div className="container">
        <PageHeader
          kicker="About SafariCo Hub"
          title="A grassroots association turning safaris into shared prosperity."
          subtitle="SafariCo Hub builds trusted partnerships between travelers, guides, operators, and the East African communities who call these landscapes home."
        />

        <div className="grid cols2" style={{ alignItems: 'start' }}>
          <Card title="Our Mission">
            <p style={{ marginTop: 0, lineHeight: 1.7, color: 'var(--muted)' }}>
              To educate, support, and fund local East African communities through ethical,
              transparent safari tourism — making sure the people protecting these lands share in
              the wealth they generate.
            </p>
          </Card>

          <Card title="Our Vision">
            <p style={{ marginTop: 0, lineHeight: 1.7, color: 'var(--muted)' }}>
              A tourism ecosystem where local communities lead, travelers give with confidence, and
              every safari contributes to real, measurable impact.
            </p>
          </Card>
        </div>

        <div className="grid cols2" style={{ alignItems: 'start', marginTop: 14 }}>
          <Card title="Our Values">
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {values.map((v) => (
                <span key={v} className="badge badgeAccent">
                  {v}
                </span>
              ))}
            </div>
          </Card>

          <Card title="Who We Are">
            <p style={{ marginTop: 0, lineHeight: 1.7, color: 'var(--muted)' }}>
              SafariCo Hub is a member-run association of conservationists, community organizers,
              and safari professionals across Kenya and Tanzania, working directly with the
              guides, operators, and communities in our network — and with the travelers and
              donors who fund their work.
            </p>
          </Card>
        </div>
      </div>
    </div>
  );
}

